import React, { useState } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { Button, toaster } from "evergreen-ui";

export const GET_SIGNED_URL = gql`
  query Misc_getS3SignedUrl($contentType: String!, $purpose: S3SignedUrlPurpose!) {
    misc_getS3SignedUrl(contentType: $contentType, purpose: $purpose) {
      uploadUrl
      url
    }
  }
`;

const ImageUpload = ({ onUploadComplete }) => {
  const [image, setImage] = useState(null); // Store the selected image
  const [imageUrl, setImageUrl] = useState(null); // Store the final image URL
  const [isUploading, setIsUploading] = useState(false);

  // Use useLazyQuery to get signed URL when you trigger it
  const [getSignedUrl, {loading, data }] = useLazyQuery(GET_SIGNED_URL);

  // Handle the file input change
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      // Request a signed URL from the GraphQL API
      getSignedUrl({
        variables: {
          contentType: file.type,
          purpose: "communication", // Adjust based on your needs
        },
      });
      setImage(file);
    } catch (error) {
      toaster.danger(`Error getting signed URL: ${error}`);
    }
  };

  // Check if the data (signed URL) is ready
  const handleUpload = async (file) => {
    if (data) {
      const { uploadUrl, url } = data.misc_getS3SignedUrl;
      try {
        // Upload the image file (binary data) to the signed URL
        await uploadImageToS3(file, uploadUrl);

        // Set the image URL and trigger the callback
        setImageUrl(url);
        if (onUploadComplete) {
          onUploadComplete(url); // Pass the uploaded URL back to the parent
        }
      } catch (error) {
        toaster.danger(`Error uploading image to S3: ${error}`);
      }
    }
  };

  // Function to upload image to S3 using the signed URL
  const uploadImageToS3 = async (file, uploadUrl) => {
    setIsUploading(true);

    try {
      await fetch(uploadUrl, {
        method: "PUT",
        headers: {
          "Content-Type": file.type, // Set appropriate MIME type (e.g., image/jpeg, image/png)
        },
        body: file, // Upload the raw binary file data
      });
    } catch (error) {
      toaster.danger(`Error uploading image to S3: ${error}`);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div>
      <input type="file" placeholder="Choose file and click upload" accept="image/*" onChange={handleFileChange} />

      {loading && <p>Getting signed URL...</p>}
      {isUploading && <p>Uploading documents...</p>}
      {/* { && */}
        {(!isUploading && data && !imageUrl) && (
          <div className="row">
            <div className="col s12">
              <Button  disabled={!data}   onClick={() => handleUpload(image)}>
                Upload Image
              </Button>
            </div>
          </div>
        )}
      {/* } */}
      {imageUrl && (
          <div className="row">
            <div className="col s12">
              <p>Image URL:</p>
              <a href={imageUrl} target="_blank" rel="noopener noreferrer">
                {imageUrl}
              </a>
            </div>
          </div>
      )}

    </div>
  );
};

export default ImageUpload;
